import { render, staticRenderFns } from "./SmartContracts.vue?vue&type=template&id=796ac0e9&"
import script from "./SmartContracts.vue?vue&type=script&lang=js&"
export * from "./SmartContracts.vue?vue&type=script&lang=js&"
import style0 from "./SmartContracts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports